import React, {FC, useState} from 'react'
import {ComingSoon} from '../../common/ComingSoon'
import MainEngineConsumptionPage from './MainEngineConsumptionPage'
import MachineryStatusPage from './MachineryStatusPage'
import MonthsEndReportPage from './MonthsEndReportPage'
import AccountsMonthEndReportPage from './AccountsMonthEndReportPage'

type Tab = 'main-engine' | 'machinery-status' | 'months-end-report' | 'accounts-report'

const MonthEndLibraryPage: FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('main-engine')

  return (
    <>
      {/* Tab navigation */}
      <div className='card mb-5'>
        <div className='card-header border-0 pt-5 pb-0'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Month End Library</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>
              Monthly vessel performance, machinery and library reports
            </span>
          </h3>
        </div>
        <div className='card-body pt-3 pb-0'>
          <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-0 fs-6'>
            <li className='nav-item'>
              <a
                className={`nav-link fw-semibold ${activeTab === 'main-engine' ? 'active' : ''}`}
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab('main-engine')
                }}
              >
                <i className='bi bi-speedometer2 me-2'></i>
                Main Engine Consumption
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link fw-semibold ${activeTab === 'machinery-status' ? 'active' : ''}`}
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab('machinery-status')
                }}
              >
                <i className='bi bi-gear me-2'></i>
                Machinery Status
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link fw-semibold ${activeTab === 'months-end-report' ? 'active' : ''}`}
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab('months-end-report')
                }}
              >
                <i className='bi bi-hourglass-split me-2'></i>
                Months End Report
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link fw-semibold ${activeTab === 'accounts-report' ? 'active' : ''}`}
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab('accounts-report')
                }}
              >
                <i className='bi bi-calculator me-2'></i>
                Accounts Month End Report
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Tab content */}
      {activeTab === 'main-engine' && <MainEngineConsumptionPage />}
      {activeTab === 'machinery-status' && <MachineryStatusPage />}
      {activeTab === 'months-end-report' && <MonthsEndReportPage />}
      {activeTab === 'accounts-report' && <AccountsMonthEndReportPage />}
    </>
  )
}

export default MonthEndLibraryPage
export { MonthEndLibraryPage }
